import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { ConstantUtil } from '@/utils/ConstantUtil';
import { IRegionsResponse, GetDistrictsResponse } from '@/types/regions';

export const categoryApi = createApi({
  reducerPath: 'categoryApi',
  baseQuery: fetchBaseQuery({ baseUrl: ConstantUtil.API_BASE_URL }),
  tagTypes: ['Category'],
  endpoints: (builder) => ({
    getRegions: builder.query<IRegionsResponse, { includeDistricts?: boolean }>({
      query: (params) => ({
        url: ConstantUtil.API_GET_REGIONS,
        method: 'GET',
        params,
      }),
      providesTags: ['Category'],
    }),
    getDistricts: builder.query<GetDistrictsResponse, string>({
      query: (cityKey) => ({
        url: `${ConstantUtil.API_GET_DISTRICTS}/${cityKey}/districts`,
        method: 'GET',
      }),
      providesTags: ['Category'],
    }),
  }),
});

export const { useGetRegionsQuery, useGetDistrictsQuery } = categoryApi;
